import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { updatePalletizedMeasurements } from "../api/palletizedMeasurements";
import { getVisitImageUrl } from "../utils/getImageUrl";

const PalletizedMeasurementsPanel = ({ palletizedMeasurements, onChange }) => {
  const [selectedMeasurement, setSelectedMeasurement] = useState(null);
  const [originalMeasurement, setOriginalMeasurement] = useState(null);
  const [displayModal, setDisplayModal] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);

  const handleInputChange = (field, value) => {
    setSelectedMeasurement((prevMeasurement) => ({
      ...prevMeasurement,
      [field]: value,
    }));
  };

  const showToast = (severity, summary, detail) => {
    toast.current.show({ severity, summary, detail });
  };

  const toast = React.useRef(null);

  const handleUpdateClick = () => {
    if (selectedMeasurement && selectedMeasurement.id) {
      updatePalletizedMeasurements(selectedMeasurement, selectedMeasurement.id)
        .then(() => {
          const updatedMeasurements = [
            ...palletizedMeasurements.filter(
              (m) => m.id !== selectedMeasurement.id
            ),
            selectedMeasurement,
          ];
          const sortedMeasurements = updatedMeasurements.sort(
            (a, b) => sortOrder * (a.id - b.id)
          );
          onChange(sortedMeasurements);
          setDisplayModal(false);
          showToast("success", "Éxito", "Medición actualizada correctamente");
        })
        .catch((error) => {
          console.error("Error al actualizar Palletized Measurements:", error);
          showToast("error", "Error", "Error al actualizar la medición");
        });
    }
  };

  const openModal = (measurement) => {
    setSelectedMeasurement(measurement);
    setOriginalMeasurement({ ...measurement });
    setDisplayModal(true);
  };

  const closeModal = () => {
    setSelectedMeasurement(null);
    if (originalMeasurement) {
      setSelectedMeasurement({ ...originalMeasurement });
      setOriginalMeasurement(null);
    }
    setDisplayModal(false);
  };

  const handleDeleteImage = (index) => {
    const updatedMeasurement = { ...selectedMeasurement };
    const updatedDocuments = JSON.parse(updatedMeasurement.documents || "[]");
    updatedDocuments.splice(index, 1);
    updatedMeasurement.documents = JSON.stringify(updatedDocuments);
    setSelectedMeasurement(updatedMeasurement);
  };

  return (
    <div>
      <Accordion>
        <AccordionTab header="Palletizaje">
          <DataTable
            value={palletizedMeasurements}
            selectionMode="single"
            selection={selectedMeasurement}
            onSelectionChange={(e) => openModal(e.value)}
            onSort={(e) => setSortOrder(e.sortOrder)}
          >
            <Column field="room_code" header="Cod Cámara"></Column>
            <Column
              field="room_temperature"
              header="Temperatura Cámara"
            ></Column>
            <Column
              field="pulp_temperature"
              header="Temperatura Pulpa"
            ></Column>
            <Column
              field="relative_humidity"
              header="Humedad Relativa"
            ></Column>
            <Column field="comment" header="Comentario" />
          </DataTable>

          <Dialog
            visible={displayModal}
            header={"Editar Medición de Palletizaje"}
            style={{ width: "50vw" }}
            onHide={closeModal}
          >
            <div>
              <div className="field-title">Código de cámara</div>
              <InputText
                value={selectedMeasurement?.room_code || ""}
                onChange={(e) => handleInputChange("room_code", e.target.value)}
                placeholder="Código de cámara"
              />

              <div className="field-title">Temperatura de cámara</div>
              <InputText
                value={selectedMeasurement?.room_temperature || ""}
                onChange={(e) =>
                  handleInputChange("room_temperature", e.target.value)
                }
                placeholder="Temperatura de cámara"
              />

              <div className="field-title">Temperatura de Pulpa</div>
              <InputText
                value={selectedMeasurement?.pulp_temperature || ""}
                onChange={(e) =>
                  handleInputChange("pulp_temperature", e.target.value)
                }
                placeholder="Temperatura de Pulpa"
              />

              <div className="field-title">Humedad Relativa</div>
              <InputText
                value={selectedMeasurement?.relative_humidity || ""}
                onChange={(e) =>
                  handleInputChange("relative_humidity", e.target.value)
                }
                placeholder="Humedad Relativa"
              />

              <div className="field-title">Comentario</div>
              <InputTextarea
                autoResize={true}
                value={selectedMeasurement?.comment || ""}
                onChange={(e) => handleInputChange("comment", e.target.value)}
                placeholder="Comentario"
              />
              {selectedMeasurement &&
              selectedMeasurement.documents &&
              JSON.parse(selectedMeasurement.documents).length > 0 ? (
                <div>
                  <div className="field-title">Imágenes</div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {Array.isArray(
                      JSON.parse(selectedMeasurement.documents)
                    ) ? (
                      JSON.parse(selectedMeasurement.documents).map(
                        (document, index) => {
                          try {
                            const documentData = document;
                            const imageUrl = getVisitImageUrl(
                              documentData.name
                            );

                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  marginRight: "10px",
                                }}
                              >
                                <img
                                  src={imageUrl}
                                  alt={`Documento ${documentData.name}`}
                                  style={{ width: "100px", height: "100px" }}
                                />
                                <i
                                  className="pi pi-trash"
                                  style={{
                                    cursor: "pointer",
                                    color: "red",
                                    marginTop: "2px",
                                  }}
                                  onClick={() => handleDeleteImage(index)}
                                />
                              </div>
                            );
                          } catch (error) {
                            console.error(
                              "Error al parsear el documento:",
                              error
                            );
                            return (
                              <div key={index}>
                                <span style={{ color: "red" }}>
                                  Error al procesar la imagen.
                                </span>
                              </div>
                            );
                          }
                        }
                      )
                    ) : (
                      <div>No hay imágenes válidas.</div>
                    )}
                  </div>
                </div>
              ) : (
                <div>No hay imágenes asociadas.</div>
              )}
              <div className="p-mt-2">
                <Button
                  label="Guardar"
                  icon="pi pi-check"
                  onClick={handleUpdateClick}
                />
              </div>
            </div>
          </Dialog>
        </AccordionTab>
      </Accordion>
      <Toast ref={toast} />
    </div>
  );
};

export default PalletizedMeasurementsPanel;
